import {useCallback, useEffect, useRef, useState} from 'react'
import {SActionBtn, SLowcodeList, SMessage, STableActions,} from 'shj-components'
import {Button, message, Modal} from 'antd'
import {fileDownload} from '@/utils/download'
import Upload from '@/components/Upload/ImageUpload'
import {
  dcpAppUserDeleteById,
  dcpAppUserGet,
  dcpAppUserImportInfoExcel,
  dcpAppUserIncrementalSyncKjl2Shj,
  dcpAppUserReturn,
} from '@/services/kuAccount'
import {debounce, get} from 'lodash-es';
import config from './config';
import ModifyModalDom from './modify/index';
import {ExclamationCircleFilled} from '@ant-design/icons';
import UseRecord from './modify/useRecord';
import {fetchList, getAccountState, getPostAuth} from './function';
import {httpOrgList} from "@/services/homeService.ts";
import {getUser} from '@/common/utils.ts'
import {getAuth} from "@/utils/auth.ts";
import UrlConfig from "@/api/UrlConfigs.ts";

const {confirm} = Modal;

const PageKuJaLeAccount = () => {

  const listRef = useRef<any>()
  const [isVisible, setIsVisible] = useState(false);
  const [currentRecord, setCurrentRecord] = useState<any>();
  const [companyList, setCompanyList] = useState([]);
  const [loadingImport, setLoadingImport] = useState(false);
  const [loading, setLoading] = useState(false);
  const userData = getUser() || {};
  const [curUseAccount, setCurUseAccount] = useState<any>({}); //当前领取账号
  const [authData, setAuthData] = useState<any>([]); //释放按钮岗位
  const [isVisibleRecord, setIsVisibleRecord] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    getAccountState(setCurUseAccount);
    getPostAuth(setAuthData);
  }, [])

  // 获取筛选项
  const getSelection = () => {
    return new Promise((resolve, reject) => {
      Promise.all([httpOrgList()])
          .then(
              resp => {
                const listObj = {
                  companyList: [...resp[0]],
                }
                setCompanyList([...resp[0]]);
                resolve(listObj)
              }
          )
          .catch(reject)
    })
  }

  // 刷新
  const reloadFn = () => {
    const {
      current: {reload},
    } = listRef;
    reload();
  };

  const onEdit = useCallback((record: Record<string, any>) => {
    setIsVisible(true)
    setCurrentRecord(record)
  }, []);

  const onDel = useCallback( ({id}: { id: number }) => {
    SMessage.delete({
      content: '是否确定删除该酷家乐账号',
      onOk(){
        return dcpAppUserDeleteById(id).then(async res => {
          messageApi.success(res?.message);
          await getAccountState(setCurUseAccount);
          reloadFn()
        });
      }
    })

  }, []);

  const onAdd = useCallback(() => {
    setIsVisible(true)
  }, []);

  const onUseRecord = useCallback(() => {
    setIsVisibleRecord(true)
  }, []);

  //导入
  const handleChange = (upload: any) => {
    const {file, onSuccess, onError} = upload
    const data = new FormData()
    data.append('file', file)
    return dcpAppUserImportInfoExcel(data)
        .then((res: any) => {
          const msg = get(res, 'data.message') || ''
          if (msg.indexOf('status 400') > -1) {
            // const matches = msg.match(/"message":"(.*?)"/g);
            // console.logList(matches);
            message.error(RegExp.$1.replace(/"/, ''))
          } else {
            reloadFn()
            onSuccess && onSuccess()
            message.success('导入成功')
          }
        })
        .catch(onError)
  }

  // 领取账号按钮显示
  const showGetBtn = (record: any) => {
    return userData?.companyId === record.companyCode &&
        !curUseAccount?.id &&
        !record?.lastUser;
  };

  // 释放账号按钮显示
  const showReturnBtn = (record: any) => {
    const post = userData?.userIdentity?.roleCode; //当前岗位
    const showType2 = !!authData.find((e) => e == post); //判断岗位权限
    return !!(((userData?.companyId == record.companyCode &&
                curUseAccount?.id == record?.id) ||
            showType2) &&
        record?.lastUser);
  };

  // 领取账号
  const onGetAccount = debounce(
      async (appuid: any) => {
        const res = await dcpAppUserGet({appId: appuid});
        messageApi.info(res?.data);
        await getAccountState(setCurUseAccount);
        reloadFn();
      },
      2000,
      {
        leading: true,
        trailing: false,
      },
  );

  // 释放账号
  const onReturnAccount = debounce(
      (appuid: any) => {
        message.loading('释放中，请稍后', 0)
        dcpAppUserReturn({appuid: appuid, workNumber: userData?.workerNumber}).then(async res => {
          message.destroy()
          messageApi.info(res?.data);
          await getAccountState(setCurUseAccount);
          reloadFn();
        }).catch((res) => {
          message.destroy()
          messageApi.error(res?.message);
        })
      },
      2000,
      {
        leading: true,
        trailing: false,
      },
  );

  const onUpdateKjlInfo = () => {
    confirm({
      title: '是否确定更新酷家乐账户信息',
      icon: <ExclamationCircleFilled/>,
      onOk() {
        return dcpAppUserIncrementalSyncKjl2Shj({}).then(res => {
          message.success(res.data || '操作成功')
        })
      },
    });
  };

  //下载模板
  const onDownload = () => {
    setLoading(true)
    message.loading('下载中，请稍后', 0)
    fileDownload(UrlConfig.PlusCrmWeb.DcpAppUserDownLoad)
        .then(() => {
          setLoading(false)
          message.destroy()
        })
        .catch(() => {
          setLoading(false)
          message.destroy()
        })
    // fileDownload('/plus-crm-web/dcpAppUser/downloadTemplate');
  }

  const extension = {
    auth: getAuth(),
    request: {fetchList, getSelection},
    events: {onAdd, onUpdateKjlInfo, onUseRecord, onDownload},
    onSearchFinish() {
      getAccountState(setCurUseAccount);
    },
    customRender: {
      actionTool(text: any, record: any) {
        return (
            <STableActions>
              <SActionBtn auth="kuklerAccountDelBtn"
                          onClick={() => onDel(record)} danger>
                删除
              </SActionBtn>
              <SActionBtn auth="kuklerAccountEditBtn" onClick={() => onEdit(record)} primary="true">
                编辑
              </SActionBtn>
              {showGetBtn(record) ? (
                  <SActionBtn
                      auth="kuklerAccountGetBtn"
                      onClick={() => {
                        onGetAccount(record?.appuid);
                      }}
                      primary="true"
                  >
                    领取账号
                  </SActionBtn>
              ) : null}
              {showReturnBtn(record) ? (
                  <SActionBtn
                      auth="kuklerAccountReleaseBtn"
                      onClick={() => {
                        onReturnAccount(record?.appuid);
                      }}
                      primary="true"
                  >
                    释放账号
                  </SActionBtn>
              ) : null}
            </STableActions>
        );
      },
      importInfoExcel(text: any, record: any) {
        return (
            <Upload listType="text" customRequest={handleChange} itemRender={() => null}>
              <Button loading={loadingImport}>{loadingImport ? '导入中....' : '导入'}</Button>
            </Upload>
        );
      },
    },
  }

  return (
      <div>
        {contextHolder}
        <SLowcodeList
            searchMode={'group'}
            config={config}
            ref={listRef}
            {...extension}
            rowKey={'id'}
            listTitle={'酷家乐账号列表'}
        />
        {
          isVisible ?
              <ModifyModalDom
                  open={isVisible}
                  record={currentRecord}
                  companyList={companyList}
                  onClose={() => {
                    setCurrentRecord(undefined)
                    setIsVisible(false)
                  }}
                  reload={() => listRef.current.reload()}
              /> : null
        }
        {
          isVisibleRecord ?
              <UseRecord
                  open={isVisibleRecord}
                  companyList={companyList}
                  onClose={() => {
                    setIsVisibleRecord(false)
                  }}
                  reload={() => listRef.current.reload()}
              /> : null
        }
      </div>
  )
}

export default PageKuJaLeAccount